module.exports = __webpack_public_path__ + "static/help-figur1-f137aae2007443010dc2f3b0bd08ff88.png";